export function randomCode(length = 32): string {
    let array = new Uint8Array(length);
    array = crypto.getRandomValues(array);
    return String.fromCharCode.apply(null, Array.from(array));
}
